/**
 * Media Service — public-web build-time variant.
 *
 * Asset URLs are fetched from `mediadb/assets` at build time by
 * scripts/fetch-media-assets.mjs and baked into src/generated/media-urls.ts.
 * No runtime Firestore reads, no caching layer — every lookup is a synchronous
 * dictionary access against the generated map.
 *
 * Trade-off vs. the deprecated runtime-fetch pattern: URL changes in mediadb
 * require a code deploy to take effect on the public site. Worth it because
 * the public-web asset surface is small and stable, and the runtime story is
 * dramatically simpler (no cold-load flash, no localStorage cache, no
 * mediadb runtime dependency).
 *
 * To refresh the snapshot locally: `npm run sync-media` (requires a service
 * account — see .env.example).
 */

import { MEDIA_ASSETS, MEDIA_URLS } from '@generated/media-urls';
import type { MediaAsset } from '@app-types/media-asset';

export function getAsset(name: string): MediaAsset | null {
  return MEDIA_ASSETS[name] ?? null;
}

export function getCachedAssetUrl(name: string): string | null {
  return MEDIA_URLS[name] ?? null;
}
